import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-business-menu',
  templateUrl: './business-menu.component.html',
  styleUrls: ['./business-menu.component.css']
})
export class BusinessMenuComponent implements OnInit {
    businessId;

    public menu?: Menu;

    public deleting = false;

    public businessNameButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'businesslang', gotoParms: () => this.menu!.business_id ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.businessId = this.stateService.getStateParams()['business_id'];
    }

    private async loadMenu() {
        if (!!this.businessId) {
            this.menu = (await this.datatask.Post(1143, { business_id: this.businessId }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.menu) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(1147, this.menu);

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    business_id: string;
    business_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('businessMenu', {
//        templateUrl: 'views/components/views/businessMenu/businessMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'businessMenuService', function ($stateParams, stateService, translateService, modalService, businessMenuService) {
//            const vm = this;
//            let businessId = $stateParams.business_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                businessNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('businesslang', { business_id: vm.model.menu.business_id }) }
//                ],
//                menu: {},
//                lockedDelete: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadMenu() {
//                vm.model.menu = (await businessMenuService.getMenu({ business_id: businessId }))[0];
//            }

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    businessMenuService.deleteItem(vm.model.menu).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            };
//        }]
//    });
//})();
